import React from 'react';
import { ApiLink } from '../../../APILink/ApiLink';
import './PrintableFolder.scss';

/**
 * @typedef {Object} PrintableFolderData
 * @property {string} documentType
 * @property {string} period
 * @property {string} companyName
 * @property {string} companyId
 * @property {string} companyAddress
 * @property {string} email
 * @property {string} telephone
 * @property {string} logo
 */

/**
 * @param {Object} props
 * @param {PrintableFolderData} props.data
 */
export default function PrintableFolder({ data }) {
  return (
    <div className="PrintableFolder__page">
      {/* Header */}
      <header className="PrintableFolder__header">
        <div className="PrintableFolder__headerTop">
          <div className="PrintableFolder__logoContainer">
            {data.logo ? (
              <img src={ApiLink.PHOTO_URL + data.logo} alt="Company Logo" className="PrintableFolder__logoImg" />
            ) : (
              <div className="PrintableFolder__logoPlaceholder"></div>
            )}
          </div>
          <div className="PrintableFolder__headerInfo">
            <h1 className="PrintableFolder__companyName">
              {data.companyName || 'EMRI I KOMPANISË'}
            </h1>
            <div className="PrintableFolder__companyDetails">
              <div className="PrintableFolder__detailsColumn">
                <div className="PrintableFolder__detailRow">
                  <span className="PrintableFolder__detailLabel">NUI:</span>
                  <span className="PrintableFolder__detailValue">{data.companyId || '—'}</span>
                </div>
                <div className="PrintableFolder__detailRow">
                  <span className="PrintableFolder__detailLabel">Telefon:</span>
                  <span className="PrintableFolder__detailValue">{data.telephone || '—'}</span>
                </div>
              </div>
              <div className="PrintableFolder__detailsColumn">
                <div className="PrintableFolder__detailRow">
                  <span className="PrintableFolder__detailLabel">Adresa:</span>
                  <span className="PrintableFolder__detailValue">{data.companyAddress || '—'}</span>
                </div>
                <div className="PrintableFolder__detailRow">
                  <span className="PrintableFolder__detailLabel">Email:</span>
                  <span className="PrintableFolder__detailValue">{data.email || '—'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="PrintableFolder__headerDivider"></div>
        <p className="PrintableFolder__companySubtitle PrintableFolder__companySubtitle--below">
          Dokumentacion për arkivim
        </p>
      </header>

      {/* Body */}
      <main className="PrintableFolder__main">
        <div className="PrintableFolder__mainContent">
          <div className="PrintableFolder__decorativeBox">
            <div className="PrintableFolder__documentBadge">KOPERTINË DOKUMENTI</div>
            <div className="PrintableFolder__documentSection">
              <span className="PrintableFolder__sectionLabel">DOKUMENT</span>
              <h2 className="PrintableFolder__title">
                {data.documentType || 'LLOJI I DOKUMENTIT'}
              </h2>
            </div>

            <div className="PrintableFolder__divider"></div>

            <div className="PrintableFolder__periodSection">
              <span className="PrintableFolder__sectionLabel">PERIUDHA</span>
              <h3 className="PrintableFolder__period">
                {data.period || 'MUAJI/VITI'}
              </h3>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="PrintableFolder__footer">
        <div className="PrintableFolder__footerDivider"></div>
        <div className="PrintableFolder__footerContent">
          <p className="PrintableFolder__footerSoftware">Gjeneruar nga Accountree</p>
        </div>
      </footer>
    </div>
  );
}
